
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quizzes/leaderboard",
      function () {
        return require("private-next-pages/quizzes/leaderboard.tsx");
      }
    ]);
  